export const FILE_SIZE_LIMIT_IN_MB = 10; // 10 MB - images above this are compressed automatically
export const FILE_SIZE_LIMIT_IN_BYTES = FILE_SIZE_LIMIT_IN_MB * 1024 * 1024;

export const ATTACHMENT_FILE_SIZE_LIMIT_IN_MB = 2;
export const ATTACHMENT_FILE_SIZE_LIMIT_IN_BYTES = ATTACHMENT_FILE_SIZE_LIMIT_IN_MB * 1024 * 1024;